import { BriefcaseIcon, GraduationCapIcon, LandmarkIcon, PawPrintIcon, PlaneIcon, type LucideIcon } from 'lucide-react'
import type { SectorKey } from '../../data/sectors'

export const SECTOR_ICONS: Record<SectorKey, LucideIcon> = {
  cities: LandmarkIcon,
  professional: BriefcaseIcon,
  animal: PawPrintIcon,
  campus: GraduationCapIcon,
  airports: PlaneIcon,
}
